import React from 'react';
import PropTypes from 'prop-types';

import styles from './shareUrlPopUp.scss';

class ShareUrlPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuShowed: false,
            displayMenuBelowAnchor: true,
            displayCopied: false,
        };
        this.handleAchorClick = this.handleAchorClick.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.setInputRef = this.setInputRef.bind(this);
        this.copyTextToClipboard = this.copyTextToClipboard.bind(this);
        this.fallbackCopyText = this.fallbackCopyText.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('touchend', this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchend', this.handleClickOutside, false);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setInputRef(node) {
        this.input = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isMenuShowed) {
            this.closePopUp();
        }
    }

    handleAchorClick(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        if (navigator.share) {
            const shareUrl = this.props.url || window.location.href;
            // A share message has to ride inside `text`: iMessage/Notes drop `text` when a
            // separate `url` is present (Notes shows only a link card), and `title` just prepends
            // noise to the sent message. So when there is share text, send message + link as one
            // `text` and omit title/url; without it, keep the plain title/link behavior.
            const shareData = this.props.shareText
                ? { text: `${this.props.shareText}\n${shareUrl}` }
                : { title: this.props.title || 'Copy Link', text: '', url: shareUrl };
            navigator.share(shareData).then(() => {
                if (this.props.onShareComplete) {
                    this.props.onShareComplete();
                }
            }).catch(() => {
                // Swallow: a rejection here is the user dismissing the native share sheet.
            });
        } else {
            this.showPopUp(ev);
        }
    }

    showPopUp(ev) {
        const parentRect = ev.target.parentElement.getBoundingClientRect();
        // width reduced for Iphone 5 and small resolution devices
        let width = 300;
        if (window.innerWidth > 500) {
            width = 400;
        }
        // Values from left border
        let right = false;
        let transformValue = 'translateX(-50%)';
        if (parentRect.left > window.innerWidth / 2) {
            // Values from right border
            right = true;
            transformValue = 'translateX(50%)';
        }
        const distanceFromBorder = right ? window.innerWidth - parentRect.right : parentRect.left;
        if (distanceFromBorder < width / 2) {
            if (right) {
                transformValue = `translateX(${distanceFromBorder - 10}px)`;
            } else {
                transformValue = `translateX(${-distanceFromBorder + 10}px)`;
            }
        }
        if (this.props.translateXValue) {
            transformValue = `translateX(${this.props.translateXValue})`;
        }
        let showBelow = true;
        if (ev.nativeEvent.clientY > (2 * window.innerHeight / 3)) {
            showBelow = false;
        }
        this.setState({
            isMenuShowed: true,
            displayMenuBelowAnchor: showBelow,
            hoverWidth: `${width}px`,
            rightAlign: right,
            transformValue,
        });
    }

    copyTextToClipboard(copyText, ev) {
        const thisCopy = this;
        const contentToCopy = this.props.shareText ? `${this.props.shareText}\n${copyText}` : copyText;
        if (navigator.clipboard) {
            navigator.clipboard.writeText(contentToCopy).then(() => {
                thisCopy.closePopUp(true);
            }, (err) => {
                console.error('Async: Could not copy text: ', err);
                thisCopy.closePopUp(false);
            });
        } else {
            this.fallbackCopyText(ev);
        }
    }

    fallbackCopyText() {
        const isIphone = navigator.userAgent.match(/ipad|iphone/i);
        let linkCopied = false;
        if (this.input) {
            let range; let
                selection;
            if (isIphone) {
                range = document.createRange();
                range.selectNodeContents(this.input);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                this.input.setSelectionRange(0, 999999);
            } else {
                this.input.select();
            }
            try {
                linkCopied = document.execCommand('copy');
            } catch (err) {
                console.error(err);
            }
        }
        this.closePopUp(linkCopied);
    }

    closePopUp(linkCopied) {
        const thisCopy = this;
        if (linkCopied) {
            thisCopy.setState({
                displayCopied: true,
            }, () => {
                setTimeout(() => {
                    thisCopy.setState({
                        isMenuShowed: false,
                        displayCopied: false,
                    });
                }, 1000);
            });
            if (this.props.linkCopied) {
                this.props.linkCopied();
            }
        } else {
            thisCopy.setState({
                isMenuShowed: false,
                displayCopied: false,
            });
        }
    }

    render() {
        const { title, subTitle, linkTitle, className, 'data-testid': dataTestId } = this.props;
        // if no invite link is passed, use current page url
        const url = this.props.url || window.location.href;

        const PopUp = () => {
            return (
                <div className={`utr-card pt24`}>
                    <div className={`${title || subTitle ? 'form-group pr24 pl24' : ''}`}>
                        {title && (
                            <h5 data-testid={dataTestId && `${dataTestId}.title`}>{title}</h5>
                        )}
                        {subTitle && (
                            <h5 className={`grey`} data-testid={dataTestId && `${dataTestId}.subtitle`}>{subTitle}</h5>
                        )}
                    </div>
                    <div className={`link-area`}>
                        <form>
                            {linkTitle && <div className={`link-title`} data-testid={dataTestId && `${dataTestId}.link-title`}>{linkTitle}</div>}
                            <div className={`form-group`}>
                                <div className="input-wrapper">
                                    <input
                                        type="text"
                                        id="url"
                                        className="form-control"
                                        value={`${url}`}
                                        ref={this.setInputRef}
                                        readOnly={false}
                                        contentEditable={true}
                                        onChange={() => {
                                            // do nothing
                                        }}
                                        data-testid={dataTestId && `${dataTestId}.url-input`}
                                    />
                                </div>
                            </div>
                        </form>
                        <div
                            className={`btn btn-large ${this.state.displayCopied ? 'btn-default' : 'btn-primary'} d-block text-uppercase`}
                            onClick={() => {
                                if (!this.state.displayCopied) {
                                    this.copyTextToClipboard(url);
                                }
                            }}
                            data-testid={dataTestId && `${dataTestId}.copy-btn`}
                        >
                            {this.state.displayCopied ? 'Link Copied' : 'Copy Invite Link'}
                        </div>

                    </div>
                </div>
            );
        };

        return (
            <div className={`menu-root ${styles.sharePopUp}`} data-testid={dataTestId}>
                <div
                    className={`menu-anchor ${className || ''}`}
                    onClick={this.handleAchorClick}
                >
                    {this.props.children || <span data-testid={dataTestId && `${dataTestId}.trigger`}><i className="uts uts-share" />Share</span>}
                </div>
                {this.state.isMenuShowed && (
                    <div className="anchor-click-disabler" />
                )}
                {this.state.isMenuShowed && (
                    <div
                        className={`menu-container ${this.state.displayMenuBelowAnchor ? 'below-anchor' : 'above-anchor'}`}
                        style={this.state.rightAlign ? {
                            width: this.state.hoverWidth,
                            right: '10px',
                            transform: this.state.transformValue,
                        } : {
                            width: this.state.hoverWidth,
                            left: '10px',
                            transform: this.state.transformValue,
                        }}
                        ref={this.setWrapperRef}
                    >
                        <PopUp />
                    </div>
                )}
            </div>
        );
    }
}

ShareUrlPopUp.propTypes = {
    url: PropTypes.string,
    title: PropTypes.string,
    shareText: PropTypes.string,
    subTitle: PropTypes.string,
    linkTitle: PropTypes.string,
    className: PropTypes.string,
    translateXValue: PropTypes.string,
    onShareComplete: PropTypes.func,
    linkCopied: PropTypes.func,
    children: PropTypes.node,
    'data-testid': PropTypes.string,
};

ShareUrlPopUp.defaultProps = {
    url: null,
    title: null,
    shareText: null,
    subTitle: null,
    linkTitle: null,
    className: null,
    translateXValue: null,
    onShareComplete: null,
    linkCopied: null,
    children: null,
    'data-testid': null,
};

export default ShareUrlPopUp;
